var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDescending = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 10", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M2.273 3.454A.3.3 0 0 1 2.53 3h4.94a.3.3 0 0 1 .257.454L5.43 7.285a.5.5 0 0 1-.858 0z" }) }))); };
export default SvgDescending;
